import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const NotAllowedChannelTextContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: ${Screen.widthRatio * 515}px;
  width: ${Screen.widthRatio * 1500}px;
`;

export default NotAllowedChannelTextContainer;
